const INCLUDE_PROPERTIES = 'Customer,Technical';

export const BUSINESS_TRIP_FORM_PARAMS = {
    includeProperties: INCLUDE_PROPERTIES,
};
